var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 33"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#211D1E",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.5 25.5C20.299 25.5 25 20.799 25 15S20.299 4.5 14.5 4.5 4 9.201 4 15s4.701 10.5 10.5 10.5M21.925 22.425 28 28.5"
})));
export default SvgSearch;